import { AlertTriangle, TrendingDown, Eye, Users, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "@/i18n";

const CostOfInaction = () => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: Eye,
      stat: "75%",
      text: t('costOfInaction.stat1'),
    },
    {
      icon: TrendingDown,
      stat: "0",
      text: t('costOfInaction.stat2'),
    },
    {
      icon: Users,
      stat: "→",
      text: t('costOfInaction.stat3'),
    },
  ];

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="glow-orb w-[500px] h-[500px] top-0 right-1/4 opacity-10" style={{ background: 'radial-gradient(circle, hsl(var(--destructive) / 0.3), transparent 70%)' }} />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-destructive/10 text-sm font-medium mb-6">
            <AlertTriangle size={16} className="text-destructive" />
            <span className="text-destructive">{t('costOfInaction.badge')}</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t('costOfInaction.title')}
          </h2>
          <p className="text-lg text-muted-foreground mb-12">
            {t('costOfInaction.subtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            {stats.map((item, i) => (
              <div key={i} className="p-6 rounded-2xl glass-card border border-destructive/10 hover-lift transition-all duration-300 text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-destructive/10 flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-destructive" />
                </div>
                <p className="text-3xl font-extrabold text-foreground mb-2">{item.stat}</p>
                <p className="text-sm text-muted-foreground">{item.text}</p>
              </div>
            ))}
          </div>

          <Link to="/auth">
            <Button variant="cta" size="xl" className="group">
              {t('costOfInaction.cta')}
              <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CostOfInaction;
